// src/components/BookNowButton/BookNowButton.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './BookNowButton.css';

interface BookNowButtonProps {
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const BookNowButton: React.FC<BookNowButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  className = '',
  disabled = false,
  onClick
}) => {
  const buttonClass = `book-now-button ${variant} ${size} ${className}`;

  const handleClick = () => {
    if (onClick && !disabled) {
      onClick();
    }
  };

  if (disabled) {
    return (
      <button 
        className={`${buttonClass} disabled`}
        disabled={true}
        onClick={handleClick}
      >
        Book Now
      </button>
    );
  }

  return (
    <Link 
      to="/submit-details"
      className={buttonClass}
      onClick={handleClick}
    >
      Book Now
    </Link>
  );
};

export default BookNowButton;